import React, { useState } from "react";
import { Modal, Button, Input, Form, notification } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import axiosInstance from "utilities/axios";
const ApprovalPopup = ({ requestId, isOpen, onClose, onChange }) => {
  const [comment, setComment] = useState("");
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);

  const handleApprove = () => {
    setApproveLoading(true);
    var approval = new FormData();
    approval.append("comments", comment);
    axiosInstance
      .post(`/equipment/requests/${requestId}/approve`, approval)
      .then((response) => {
        notification.success({
          message: "Success",
          description: "Request approved successfully",
        });
        onClose();
        onChange();
      })
      .catch((error) => {
        notification.error({
          message: "Error",
          description: error.response.data.description,
        });
      })
      .finally(() => {
        setApproveLoading(false);
      });
  };

  const handleReject = () => {
    setRejectLoading(true);
    var rejection = new FormData();
    rejection.append("comments", comment);
    axiosInstance
      .post(`/equipment/requests/${requestId}/reject`, rejection)
      .then((response) => {
        notification.success({
          message: "Success",
          description: "Request rejected successfully",
        });
        onClose();
        onChange();
      })
      .catch((error) => {
        notification.error({
          message: "Error",
          description: error.message,
        });
      })
      .finally(() => {
        setRejectLoading(false);
      });
  };

  return (
    <Modal
      title="Approve or Reject"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      destroyOnClose={true}
    >
      <Form layout="vertical">
        <Form.Item label="Add a Comment">
          <Input.TextArea
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            onClick={handleApprove}
            style={{
              backgroundColor: "green",
              borderColor: "green",
              marginRight: 8,
            }}
            loading={approveLoading}
          >
            Approve
          </Button>
          <Button
            type="primary"
            danger
            icon={<CloseCircleOutlined />}
            onClick={handleReject}
            loading={rejectLoading}
          >
            Reject
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ApprovalPopup;
